import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import queryString from 'query-string'

import styled from '@emotion/styled'
import { rgba } from 'polished'
import { env, getAppLayout } from '../../utils'

import FlyerStoresToggle from '../flyer/flyerStoresToggle.container'

import Logo from './mainHeader.logo.component'

const { hostname } = window.location
const layout = getAppLayout(hostname)

const StyledRoot = styled('header')(({ theme }) => ({
  backgroundColor: layout.projectColor,
  width: '100%',
  height: theme.spaces.default * 3,
  display: 'flex',
  borderBottom: `1px solid ${rgba(theme.colors.mid_grey, 0.2)}`,
  alignItems: 'center',
  justifyContent: 'space-between',

  [`@media (min-width: ${theme.breakpoints.medium})`]: {
    height: theme.spaces.default * 4,
    padding: theme.spaces.default / 2,
  },
}))

const countryString = env('REACT_APP_COUNTRY')
const logoPath = layout.name !== 'default' ? `/${layout.name}/main-${layout.name}` : `/main-${countryString}`
const logo = require(`../../../images/logos${logoPath}.png`)
const logo2x = require(`../../../images/logos${logoPath}@2x.png`)
class MainHeader extends Component {
  /**
   * Returns parsed url search values
   */
  get search() {
    const { location: { search } } = this.props
    return queryString.parse(search)
  }

  renderFlyerStoresToggle() {
    const { flyerId } = this.props
    if (this.search.hideFlyerStores !== 'true' && flyerId) {
      return <FlyerStoresToggle flyerId={flyerId} />
    }
    return false
  }

  render() {
    return (
      <StyledRoot>
        <Logo src={logo} srcset={`${logo} 1x, ${logo2x} 2x`} alt={env('REACT_APP_WEBAPP_NAME')} />
        {this.renderFlyerStoresToggle()}
      </StyledRoot>
    )
  }
}

MainHeader.propTypes = {
  flyerId: PropTypes.number,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
}

MainHeader.defaultProps = {
  flyerId: null,
}

export default withRouter(MainHeader)
